// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebGetFolderOffersByRealtyOfferIdRequest,
  TWebGetFolderOffersByRealtyOfferIdModel,
  IMappers,
  TWebGetFolderOffersByRealtyOfferIdResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFolderOffersByRealtyOfferIdForWebResponseSchema } from '../../../entities/get_folder_offers_by_realty_offer_id/GetFolderOffersByRealtyOfferIdForWebResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebGetFolderOffersByRealtyOfferIdModel(
  parameters: TWebGetFolderOffersByRealtyOfferIdRequest,
): TWebGetFolderOffersByRealtyOfferIdModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/get-folder-offers-by-realty-offer-id/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebGetFolderOffersByRealtyOfferIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebGetFolderOffersByRealtyOfferIdRequest;
}

export async function fetchWebGetFolderOffersByRealtyOfferId<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebGetFolderOffersByRealtyOfferIdOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebGetFolderOffersByRealtyOfferIdResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebGetFolderOffersByRealtyOfferIdModel(parameters),
    config,
  )) as FetchResponse<TWebGetFolderOffersByRealtyOfferIdResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFolderOffersByRealtyOfferIdForWebResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebGetFolderOffersByRealtyOfferIdResponse>;
}
